module.exports = __webpack_public_path__ + "static/img/slider.dca17dd6.svg";